"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
var _i18n = require("@/utils/i18n");
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      levelList: null
    };
  },
  watch: {
    $route: function $route() {
      this.getBreadcrumb();
    }
  },
  created: function created() {
    this.getBreadcrumb();
  },
  methods: {
    getBreadcrumb: function getBreadcrumb() {
      this.levelList = this.$route.matched.filter(function (item) {
        return item.name;
      });
      console.log('this.levelList', this.levelList);
    },
    generateTitle: _i18n.generateTitle
  }
};